import { PlanProps } from "../../../lib/types";
import { Badge } from "@dub/ui";
import { capitalize } from "../../../utils";

export default function PlanBadge({ plan }: { plan: PlanProps }) {
  return (
    <Badge
      variant={
        plan === "enterprise"
          ? "violet"
          : plan === "advanced"
            ? "amber"
            : plan.startsWith("business")
              ? "sky"
              : plan === "pro"
                ? "blue"
                : "black"
      }
    >
      {capitalize(plan)}
    </Badge>
  );
}
